module.exports = __webpack_public_path__ + "img/gb818-85-m6.prt.827ea74e.jpg";